import * as React from 'react'
import ReactDOM from 'react-dom/client'
import '@petz/ds-icon/dist/index.css'
import '@petz/ds-badge/dist/index.css'
import { WebSelfService } from './WebSelfService'

window['SelfServiceBallon'] = {
  root: null,
  refreshTokenFunction: null,
  create: function (props) {
    if (document == null || document.body == null) {
      setTimeout(function () {
        this.create(props)
      }, 250)
      return
    }

    if (document.getElementById('selfServiceRoot') != null) {
      this.destroy()
      this.create(props)
      return
    }

    if (props.apiUrl == null) {
      console.error("You must provide a 'apiUrl' parameter")
      return
    }

    if (props.userId == null) {
      console.error("You must provide a 'userId' parameter, if you don't have this information please provide an empty string")
      return
    }

    if (props.refreshTokenFunction == null) {
      console.error("You must provide a 'refreshTokenFunction' parameter")
      return
    }

    if (props.blipChatAppKey == null) {
      console.error("You must provide a 'blipChatAppKey' parameter")
      return
    }

    if (props.segmentKey == null) {
      console.warn('You must provide a segment writeKey to enable segment')
    }

    this.refreshTokenFunction = props.refreshTokenFunction

    const selfServiceRoot = document.createElement('div')
    selfServiceRoot.id = 'selfServiceRoot'
    document.body.appendChild(selfServiceRoot)

    this.root = ReactDOM.createRoot(selfServiceRoot)
    this.root.render(
      <React.StrictMode>
        <WebSelfService {...props} />
      </React.StrictMode>
    )
  },
  destroy: function () {
    const selfServiceRoot = document.getElementById('selfServiceRoot')

    if (selfServiceRoot === null) return

    if (this.root != null) {
      this.root.unmount()
    }
    selfServiceRoot.remove()
    this.root = null
  },
  openToChat: null,
}
